export default "__VITE_ASSET__BEMrR_47__"